import { useCallback } from 'react'
import {
    useEditorActionBarActions,
    useShallowEditorActionBar,
} from '../store/EditorActionBarStore'

/**
 * A custom hook that returns functions used for toggles and closing menu inside visibility settings popover
 */
export const useClickMenuItem = () => {
    const { visibilitySettingValues } = useShallowEditorActionBar((state) => ({
        visibilitySettingValues: state.visibilitySettingValues,
        actions: state.actions,
    }))
    const {
        setVisibilitySettingValues,
        setIsVisibilitySettingsMenuDisplayed,
    } = useEditorActionBarActions()
    const onClickMenuItem = useCallback(
        (actionType: string, actionValue: boolean) => {
            setVisibilitySettingValues?.({
                ...visibilitySettingValues,
                [actionType]: actionValue,
            })
        },
        [visibilitySettingValues, setVisibilitySettingValues]
    )
    const onCloseMainMenu = useCallback(() => {
        setIsVisibilitySettingsMenuDisplayed?.(false)
    }, [setIsVisibilitySettingsMenuDisplayed])
    return {
        onClickMenuItem,
        onCloseMainMenu,
    }
}
